  window.addEventListener('DOMContentLoaded', () => {
    const skuContainer = document.querySelector('.wt-product .wt-product__main .wt-product__info');
    if(!skuContainer) return;

    const skuParent = skuContainer.querySelector('.wt-product__sku');
    if(!skuParent) return;

    const skuProductDescription = document.querySelector('.product-description-with-sku .product-description-sku');
    console.log("SKU PDP DESCRIPTION: ", skuProductDescription)

    const observerConfig = { attributes: false, childList: true, subtree: true };
    const observerAction = () => {
      const target = skuParent.querySelector('.sku-text');
      if(!target) updateSKU();
    };

    const observer = new MutationObserver(observerAction);
    observer.observe(skuContainer, observerConfig);

    const variantSelectors = Array.from(document.querySelectorAll('.product-badge-toggler'));
    if(variantSelectors.length) variantSelectors.forEach(selector => selector.addEventListener('click', () => {
      if(observer) observer.disconnect();
      observer.observe(skuContainer, observerConfig)
    }));

    function updateSKU() {
      const textNode = skuParent.querySelector('span').nextSibling;
      if(!textNode) return;

      const textContent = textNode.textContent.trim().split(" ");
      textNode.remove();

      const skuColored = document.createElement('span');
      skuColored.classList.add('sku-text');
      skuColored.classList.add('sku--colored');
      skuColored.innerHTML = textContent[0]

      const skuNormal = document.createElement('span');
      skuNormal.classList.add('sku-text');
      skuNormal.classList.add('sku--normal');
      skuNormal.innerHTML = textContent[1]
      
      skuParent.appendChild(skuColored);
      skuParent.appendChild(skuNormal);

      updateDescriptionSKU(skuParent);

      observer.disconnect();
    }

    function updateDescriptionSKU(source) {
      if(skuProductDescription) skuProductDescription.innerHTML = source.innerHTML;
    }
  })